import React from 'react'
import PropTypes from 'prop-types'

function SmartviewText ({ children, label }) {
  const labelElement = label ? <div className='font-medium text-base mb-1'>{label}</div> : null

  return (
    <div>
      {labelElement}
      <div className='text-gray-800 text-sm'>
        {children}
      </div>
    </div>
  )
}

SmartviewText.defaultProps = {
  label: null
}

SmartviewText.propTypes = {
  label: PropTypes.node
}

export default SmartviewText
